import React from 'react';

const WikiCommonsImage = ({width, title, bottomText, bottomTextLinkUrl, wikiCommonsLink, imageSource, alt, }) => {
  return (
<div style={{marginTop:'15px', marginBottom:'15px', paddingTop:'10px', display:'flex', flexDirection:'column'}}>
          <a style={{margin:'auto'}} title={title} href={wikiCommonsLink} target="_blank" rel="noopener noreferrer"><img width={width} style={{margin:'auto', borderRadius:'5px'}} alt={alt} src={imageSource}/></a>
          <span style={{textAlign:"center"}}><a href={bottomTextLinkUrl}>{bottomText}</a></span>
    </div>
  );
};

export default WikiCommonsImage;
